import { Button, ButtonGroup, Select, Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

export type ForeignKeyOption = {
  value: string;
  label: string;
};

export type ImportTypeOption = {
  value: string;
  label: string;
};

export type ICsvImportForeignKeyConfigurationProps = {
  foreignKey: string;
  foreignKeyOptions: ForeignKeyOption[];
  onForeignKeyChange: (foreignKey: string) => void;
};

export type ICsvImportConfigurationProps = {
  importType: string;
  importTypeOptions: ImportTypeOption[];
  onImportTypeChange: (importType: string) => void;
  foreignKeyConfig?: ICsvImportForeignKeyConfigurationProps;
  /** When true, hide the Insert/Update operation picker and only show match field. */
  hideImportType?: boolean;
};

export const CsvImportConfiguration: React.FC<ICsvImportConfigurationProps> = (
  props
) => {
  const foreignKeyConfig = props.foreignKeyConfig;
  const foreignKeyConfiguration =
    foreignKeyConfig !== undefined ? (
      <Stack>
        <Text textStyle="compactStrong">Choose Match Field</Text>

        <Select
          w={280}
          mt="2"
          mb="6"
          value={foreignKeyConfig.foreignKey}
          onChange={(event) => {
            foreignKeyConfig.onForeignKeyChange(event.target.value as string);
          }}
        >
          {foreignKeyConfig.foreignKeyOptions.map((option) => {
            const { label, value } = option;
            return (
              <option value={value} key={value}>
                {label}
              </option>
            );
          })}
        </Select>
      </Stack>
    ) : null;

  const buttons = props.importTypeOptions.map((importType) => (
    <Button
      isActive={props.importType === importType.value}
      onClick={() => props.onImportTypeChange(importType.value)}
      key={importType.value}
      variant={props.importType === importType.value ? 'solid' : 'outline'}
      colorScheme={props.importType === importType.value ? 'primary' : 'gray'}
    >
      {importType.label}
    </Button>
  ));

  return (
    <Stack spacing="4">
      {!props.hideImportType && (
        <Stack>
          <Text textStyle="compactStrong">Operation</Text>
          <ButtonGroup isAttached>{buttons}</ButtonGroup>
        </Stack>
      )}
      {foreignKeyConfiguration}
    </Stack>
  );
};
